module.exports = __webpack_public_path__ + "images/6df60243ee7dbe25f3b2403d1a02d1fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/brand-logo.png
// module id = 1513
// module chunks = 1